<template>
  <div class="w-100">
    <table
      v-if="loaded"
      :class="{
        'table mt-0 mb-0 full-width': true,
        'is-loading': loading
      }">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">{{ $t('status.status') }}</th>
          <th scope="col" class="border-0">{{ $t('order.saveDate') }}</th>
          <th scope="col" class="border-0">{{ $t('users.user') }}</th>
          <th scope="col" class="border-0"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) of items"
          :key="'history-item-' + index">
          <td class="align-middle">
            {{ getStatusName(item.status)}}
          </td>
          <td class="align-middle">
            {{ item.updated_at }}
          </td>
          <td class="align-middle">
            {{ item.user_name }}
          </td>
          <td class="align-middle">
            <d-button
              theme="primary"
              @click.prevent="seeState(item.id)">
              {{ $t('order.see') }}
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />

    <order-evidence-popup
      v-if="showEvidencePopup"
      :evidenceData="selectedHistoryItem" />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import ListUtils from './../../utils/ListUtils.js';
import HasPagination from './../../mixins/HasPagination.vue';
import OrderEvidencePopup from './OrderEvidencePopup.vue';
import Pagination from './../../components/common/Pagination.vue';
import orderStatuses from './../../data/order-statuses.js';
import Vue from 'vue';

export default {
  name: 'order-evidence',
  mixins: [
    HasPagination
  ],
  props: [
    'orderID'
  ],
  components: {
    'order-evidence-popup': OrderEvidencePopup,
    'pagination': Pagination
  },
  data () {
    return {
      items: [],
      loaded: false,
      loading: false,
      selectedHistoryItem: null,
      showEvidencePopup: false
    };
  },
  mounted () {
    this.$bus.$on('close-order-evidence-popup', this.closeEvidencePopup);
    this.debouncedLoadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      this.loading = true;

      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/orders/histories/items?page=' + this.currentPage + '&order_id=' + parseInt(this.orderID, 10),
        listField: 'items',
        pagination: true,
        successAction: () => {
          this.loading = false;
        }
      });
    },
    getStatusName (status) {
      return ListUtils.getKeyLabel(orderStatuses[this.$i18n.locale], status);
    },
    seeState (historyItemID) {
      let itemToDisplay = this.items.filter(item => item.id === historyItemID);
      this.selectedHistoryItem = JSON.parse(JSON.stringify(itemToDisplay[0]));

      Vue.nextTick(() => {
        this.showEvidencePopup = true;
      });
    },
    closeEvidencePopup () {
      this.showEvidencePopup = false;

      Vue.nextTick(() => {
        this.selectedHistoryItem = null;
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('close-order-evidence-popup', this.closeEvidencePopup);
  }
}
</script>
